import { View } from "binder";
import { getAsNumber } from "../utilities";
import { PaginatorViewModel } from "./paginator-viewModel"

export class PaginatorView extends View<PaginatorViewModel>{
    GetViewUniqueId(): string {
        return "V-53AA874B-AF71-4408-9D1B-E86059377B0D"
    }
    loadHtml(): string {
        let element = require('./paginator.html').default;
        let style = require('./paginator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set pageCount(v: number) { this._pageCount = getAsNumber(v,true); } public get pageCount(): number { return this._pageCount;} private _pageCount: number;
    public set currentPage(v: number) { 
        this._currentPage = getAsNumber(v,true);
        this.writtenPage = this.currentPage;
    } public get currentPage(): number { return this._currentPage;} private _currentPage: number;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v,true); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;
    public set requestingPage(v: number) { this._requestingPage = getAsNumber(v,true); } public get requestingPage(): number { return this._requestingPage;} private _requestingPage: number;
    public set writtenPage(v: number) { this._writtenPage = getAsNumber(v,true); } public get writtenPage(): number { return this._writtenPage;} private _writtenPage: number;
    
    gotoFirst(){
        this.dataContext.gotoFirst();
    }
    gotoLast(){
        this.dataContext.gotoLast();
    }
    gotoNext(){
        this.dataContext.gotoNext();
    }
    gotoPrev(){
        this.dataContext.gotoPrev();
    }

    keyup(e:KeyboardEvent){
        switch(e.key){
            case "Esc":
            case "Escape":
                this.writtenPage = this.currentPage;
                break;
            case "Enter":
                this.dataContext.goto(this.writtenPage);
                break;
        }
    }
    lostFocus(){
        this.dataContext.goto(this.writtenPage);
    }
}
